<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ _excludeSameItem }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    excludeSameItem: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    _excludeSameItem() {
      return this.excludeSameItem ? '対象と同じ商品は比較から除外する' : ''
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
